export const BUILDING_TYPE_OPTIONS = [
	{ value: "mf_garden", label: "Multifamily (Garden)" },
	{ value: "mf_midrise", label: "Multifamily (Mid-Rise / Podium)" },
	{ value: "mf_highrise", label: "Multifamily (High-Rise)" },
	{ value: "mf_townhome", label: "Multifamily (Townhome / Walk-Up)" },
	{ value: "student_housing", label: "Student Housing" },
	{ value: "senior_living", label: "Senior Living / Assisted Living" },
	{ value: "mixed_use", label: "Mixed-Use" },
	{ value: "hotel", label: "Hotel / Hospitality" },
	{ value: "office", label: "Office" },
	{ value: "medical_office", label: "Medical Office / Outpatient" },
	{ value: "retail_center", label: "Retail (Shopping / Strip Center)" },
	{ value: "retail_standalone", label: "Retail (Standalone / Big Box)" },
	{ value: "restaurant", label: "Restaurant" },
	{ value: "industrial_warehouse", label: "Industrial / Warehouse" },
	{ value: "flex_manufacturing", label: "Flex / Manufacturing" },
	{ value: "self_storage", label: "Self-Storage" },
	{ value: "parking_structure", label: "Parking Structure" },
	{ value: "data_center", label: "Data Center" },
	{ value: "healthcare", label: "Healthcare / Hospital" },
	{ value: "education", label: "Educational / School" },
	{ value: "assembly", label: "Assembly (Worship / Theater / Event)" },
	{ value: "other", label: "Other" }
];

export const OCCUPANCY_CLASS_OPTIONS = [
	{ value: "A-1", label: "A-1 Assembly (fixed seating, theaters)" },
	{ value: "A-2", label: "A-2 Assembly (food & drink, restaurants, bars)" },
	{ value: "A-3", label: "A-3 Assembly (worship, recreation, lecture)" },
	{ value: "A-4", label: "A-4 Assembly (indoor sporting, arenas)" },
	{ value: "A-5", label: "A-5 Assembly (outdoor, stadiums, amusement)" },
	{ value: "B", label: "B Business (offices, clinics, banks)" },
	{ value: "E", label: "E Educational (K-12)" },
	{ value: "F-1", label: "F-1 Factory (moderate hazard)" },
	{ value: "F-2", label: "F-2 Factory (low hazard)" },
	{ value: "H-1", label: "H-1 High Hazard (detonation)" },
	{ value: "H-2", label: "H-2 High Hazard (deflagration)" },
	{ value: "H-3", label: "H-3 High Hazard (physical hazard)" },
	{ value: "H-4", label: "H-4 High Hazard (health hazard)" },
	{ value: "H-5", label: "H-5 High Hazard (HPM facilities)" },
	{ value: "I-1", label: "I-1 Institutional (supervised / assisted living)" },
	{ value: "I-2", label: "I-2 Institutional (medical care, hospitals, nursing)" },
	{ value: "I-3", label: "I-3 Institutional (detention)" },
	{ value: "I-4", label: "I-4 Institutional (day care)" },
	{ value: "M", label: "M Mercantile (retail, markets, showrooms)" },
	{ value: "R-1", label: "R-1 Residential (transient: hotels, motels)" },
	{ value: "R-2", label: "R-2 Residential (apartments, multifamily)" },
	{ value: "R-3", label: "R-3 Residential (one & two family)" },
	{ value: "R-4", label: "R-4 Residential (residential care, 5 to 16 occupants)" },
	{ value: "S-1", label: "S-1 Storage (moderate hazard)" },
	{ value: "S-2", label: "S-2 Storage (low hazard, parking garages)" },
	{ value: "U", label: "U Utility / Miscellaneous" }
];

export const CONSTRUCTION_TYPE_OPTIONS = [
	{ value: "I-A", label: "Type I-A (fire-resistive, noncombustible)" },
	{ value: "I-B", label: "Type I-B (fire-resistive, noncombustible)" },
	{ value: "II-A", label: "Type II-A (noncombustible, protected)" },
	{ value: "II-B", label: "Type II-B (noncombustible, unprotected)" },
	{ value: "III-A", label: "Type III-A (ordinary, protected)" },
	{ value: "III-B", label: "Type III-B (ordinary, unprotected)" },
	{ value: "IV-HT", label: "Type IV-HT (heavy timber)" },
	{ value: "IV-A", label: "Type IV-A (mass timber, 2021 IBC+)" },
	{ value: "IV-B", label: "Type IV-B (mass timber, 2021 IBC+)" },
	{ value: "IV-C", label: "Type IV-C (mass timber, 2021 IBC+)" },
	{ value: "V-A", label: "Type V-A (wood frame, protected)" },
	{ value: "V-B", label: "Type V-B (wood frame, unprotected)" }
];

export const FIRE_SUPPRESSION_OPTIONS = [
	{ value: "none", label: "None / Not Sprinklered" },
	{ value: "partial", label: "Partial Coverage" },
	{ value: "wet_pipe", label: "Wet Pipe" },
	{ value: "dry_pipe", label: "Dry Pipe" },
	{ value: "preaction", label: "Preaction" },
	{ value: "deluge", label: "Deluge" },
	{ value: "esfr", label: "ESFR (Early Suppression, Fast Response)" },
	{ value: "water_mist", label: "Water Mist" },
	{ value: "antifreeze", label: "Antifreeze (wet pipe variant)" },
	{ value: "other", label: "Other" }
];

export const NUMBER_OF_STORIES_OPTIONS = Array.from({ length: 104 }, (_, i) => ({
	value: String(i + 1),
	label: String(i + 1)
}));

export const NUMBER_OF_UNITS_OPTIONS = Array.from({ length: 1000 }, (_, i) => ({
	value: String(i + 1),
	label: String(i + 1)
}));

export const YEAR_BUILT_OPTIONS = Array.from({ length: new Date().getFullYear() - 1844 }, (_, i) => {
	const year = String(new Date().getFullYear() - i);
	return { value: year, label: year };
});
